import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PasswordResetForm } from '@/repositories/generated';
import { ErrorBody } from '@/types';

export const passwordReset = http.post(
  createMockEndpoint('/login/password/reset'),
  async ({ request }) => {
    const requestBody = await request.json() as PasswordResetForm;
    await delay(500);

    const createResponse = (): ErrorBody | object => {
      if (requestBody.password.includes('error')) {
        return {
          error: {
            code: 'MOCK_API_ERROR',
            message: 'モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。',
          },
        };
      }
      return {};
    };

    const response = createResponse();
    const statusCode = 'error' in response ? 400 : 200;

    return HttpResponse.json(response, { status: statusCode });
  },
);
